<div class="col-md-12 padding-left-0px padding-right-0px">
  <div class="row margin-left-0px margin-right-0px">
    <div class="col-md-6 padding-left-0px padding-right-0px text-align-left">
      <label class="margin-bottom-0px font-family"> {{field.Title}}</label>
    </div>
    <div class="col-md-6 padding-left-0px padding-right-0px">
      <div *ngFor="let cc of field.ValueSource | splitpipe:','">
        <div>
          <label class="margin-bottom-0px font-family"> {{cc}}</label>
          <!--<input type="radio" class="form-control font-family" value="{{cc}}" name="{{i}}"
                 [(ngModel)]="field.Value"
                 placeholder="Value" checked="checked">-->

        </div>


      </div>
      <!--<input class="form-control " [(ngModel)]="field.Value" type="text" [ngModelOptions]="{standalone: true}" />-->



    </div>

  </div>

</div>
